export default __webpack_public_path__ + "static/media/fmt_bg.2f26bc1d.png";